import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { getConsent, setConsent, trackEvent } from "@/lib/analytics";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsent() === null) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    setConsent(value);
    trackEvent("cookie_consent", { decision: value });
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6 sm:pb-6"
          role="dialog"
          aria-label="Souhlas s cookies"
          data-testid="cookie-consent"
        >
          <div className="mx-auto flex max-w-3xl flex-col gap-5 rounded-lg border border-white/10 bg-navy-deep/95 p-6 shadow-2xl backdrop-blur-xl sm:flex-row sm:items-center">
            <p className="flex-1 text-sm leading-relaxed text-cream/75">
              Web používá nezbytné cookies pro své fungování. Analytické a marketingové nástroje
              spustíme jen s tvým souhlasem. Více v{" "}
              <Link to="/ochrana-osobnich-udaju" className="text-copper underline underline-offset-2">
                ochraně osobních údajů
              </Link>
              .
            </p>
            <div className="flex shrink-0 gap-3">
              <button
                type="button"
                onClick={() => decide("rejected")}
                data-testid="cookie-reject"
                className="rounded-full border border-white/20 px-5 py-2.5 text-xs font-semibold uppercase tracking-wider text-cream/70 transition-colors hover:border-cream/50 hover:text-cream"
              >
                Odmítnout
              </button>
              <button
                type="button"
                onClick={() => decide("accepted")}
                data-testid="cookie-accept"
                className="rounded-full bg-copper px-5 py-2.5 text-xs font-semibold uppercase tracking-wider text-navy-deep transition-colors hover:bg-cream"
              >
                Přijmout
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
